
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'6-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>결제 관리 - 결제 현황</p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn02" v-on:click="edit" v-if="admin_number === 0">수정</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 결제대기는 <span style="color: blue;font-weight: bolder;">파란색</span>, 예약취소요청은 <span style="color: red;font-weight: bolder;">빨간색</span>으로 표시됩니다.</p>
          </div>
          <button @click="toggleSearchPanel" class="Admin_toggleSearch_openBtn">
            검색
          </button>
          <div class="Admin_toggleSearchWrap" v-if="isPanelVisible">
            <div class="Admin_toggleSearcTit">
              <p>검색조건</p>
              <button class="Admin_toggleSearch_closeBtn" @click="toggleSearchPanel"></button>
            </div>
            <div v-if="admin_number === 0" class="Admin_toggleSearcBox">
              <label for="reservation_join_division">예약구분</label>
              <select id="reservation_join_division" v-model="reservation_join_division">
                <option value=''>전체</option>
                <option value='0'>일반</option>
                <option value='1'>코레일</option>
              </select>
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="travel_product_name">여행상품명</label>
              <input
                  type='text'
                  id="travel_product_name"
                  placeholder = "여행상품명을 입력해주세요."
                  v-model="travel_product_name"
                  @keydown.enter="fetchDataWithParams"
                />
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="reservation_customer_name">예약자명</label>
              <input
                  type='text'
                  id="reservation_customer_name"
                  placeholder = "예약자명을 입력해주세요."
                  v-model="reservation_customer_name"
                  @keydown.enter="fetchDataWithParams"
                />
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="reservation_customer_phone_number">휴대전화</label>
              <input
                  type='text'
                  id="reservation_customer_phone_number"
                  placeholder = "휴대전화를 입력해주세요."
                  v-model="reservation_customer_phone_number"
                  @keydown.enter="fetchDataWithParams"
                />
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="reservation_pay_status">결제여부</label>
              <select id="reservation_pay_status" v-model="reservation_pay_status">
                <option value=''>전체</option>
                <option value='1'>완료</option>
                <option value='2'>결제대기</option>
                <option value='3'>결제취소</option>
              </select>
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="reservation_cancellation_request_status">예약취소요청</label>
              <select id="reservation_cancellation_request_status" v-model="reservation_cancellation_request_status">
                <option value=''>전체</option>
                <option value='0'>미신청</option>
                <option value='1'>신청</option>
                <option value='2'>처리완료</option>
              </select>
            </div>
            <button @click="fetchDataWithParams" class="Admin_toggleSearch_searchBtn">검색</button>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_session_admin,
  get_reservation
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminTravelTypeManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null,
      isPanelVisible: false,
      reservation_join_division: '',
      travel_product_name: '',
      reservation_customer_name: '',
      reservation_customer_phone_number: '',
      reservation_pay_status: '',
      reservation_cancellation_request_status: '',
      admin_number: 0
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `/AdminReservationManagementAdd?reservation_ID=${this.tabulator.getSelectedData()[0].reservation_ID}`
      }
    },
    toggleSearchPanel: function () {
      this.isPanelVisible = !this.isPanelVisible
    },
    fetchDataWithParams: function () {
      const params = {
        reservation_join_division: this.reservation_join_division,
        travel_product_name: this.travel_product_name,
        reservation_customer_name: this.reservation_customer_name,
        reservation_customer_phone_number: this.reservation_customer_phone_number,
        reservation_pay_status: this.reservation_pay_status,
        reservation_cancellation_request_status: this.reservation_cancellation_request_status,
        admin_number: this.admin_number
      }
      get_reservation(params).then(result_data => {
        this.tabulator.setData(result_data)
        this.tabulator.setPage(1)
      })
    }
  },
  mounted () {
    get_session_admin().then(result => {
      this.admin_number = result.admin_number
      const params = {
        reservation_join_division: this.reservation_join_division,
        travel_product_name: this.travel_product_name,
        reservation_customer_name: this.reservation_customer_name,
        reservation_customer_phone_number: this.reservation_customer_phone_number,
        reservation_pay_status: this.reservation_pay_status,
        reservation_cancellation_request_status: this.reservation_cancellation_request_status,
        admin_number: result.admin_number
      }
      get_reservation(params).then(result_data => {
        this.tabulator = new Tabulator(this.$refs.table, {
          data: result_data,
          layout: 'fitData',
          movableRows: true,
          pagination: 'local',
          paginationSize: 100,
          paginationButtonCount: 5,
          columns: [
            {formatter: 'rowSelection',
              titleFormatter: 'rowSelection',
              headerSort: false,
              cellClick: function (e, cell) {
                cell.getRow().toggleSelect()
              }
            },
            {title: '예약ID', field: 'reservation_ID', headerSort: false},
            {title: '예약구분', field: 'reservation_join_division', headerSort: false},
            {title: '예약신청일', field: 'reservation_registe', headerSort: false},
            {title: '예약여행', field: 'travel_product_name', headerSort: false},
            {title: '출발일', field: 'schedule_start_day', headerSort: false},
            {title: '예약자명', field: 'reservation_customer_name', headerSort: false},
            {title: '휴대전화', field: 'reservation_customer_phone_number', headerSort: false},
            {title: '비상연락처', field: 'reservation_customer_phone_number_2', headerSort: false},
            {title: '이메일', field: 'reservation_customer_email', headerSort: false},
            {title: '결제방법', field: 'reservation_payment_method', headerSort: false},
            {title: '결제여부', field: 'reservation_pay_status', headerSort: false},
            {title: '예약취소요청', field: 'reservation_cancellation_request_status', headerSort: false},
            {title: '예약취소요청일자', field: 'reservation_cancellation_request_date', headerSort: false},
            {title: '예약인원(대인)', field: 'reservation_number_count', headerSort: false, hozAlign: 'right'},
            {title: '예약인원(소인)', field: 'reservation_number_count_child', headerSort: false, hozAlign: 'right'},
            {
              title: '단가(대인)',
              field: 'reservation_number_price',
              headerSort: false,
              formatter: 'money',
              hozAlign: 'right',
              formatterParams: {
                decimal: '.',
                thousand: ',',
                symbol: '₩',
                precision: 0
              }
            },
            {
              title: '소인(대인)',
              field: 'reservation_number_price_child',
              headerSort: false,
              formatter: 'money',
              hozAlign: 'right',
              formatterParams: {
                decimal: '.',
                thousand: ',',
                symbol: '₩',
                precision: 0
              }
            },
            {title: '총 예약인원', field: 'total_reservation_number_count', headerSort: false, hozAlign: 'right'},
            {
              title: '결제예정금액',
              field: 'reservation_expected_payment_amount',
              headerSort: false,
              formatter: 'money',
              hozAlign: 'right',
              formatterParams: {
                decimal: '.',
                thousand: ',',
                symbol: '₩',
                precision: 0
              }
            },
            {
              title: '결제완료금액',
              field: 'reservation_payment_amount',
              headerSort: false,
              formatter: 'money',
              hozAlign: 'right',
              formatterParams: {
                decimal: '.',
                thousand: ',',
                symbol: '₩',
                precision: 0
              }
            },
            {
              title: '수수료',
              field: 'reservation_fee',
              headerSort: false,
              hozAlign: 'right',
              formatter: function (cell) {
                let value = cell.getValue()
                if (value == null || value === '') return ''
                return value + '%'
              }
            },
            {
              title: '정산금액',
              headerSort: false,
              hozAlign: 'right',
              formatter: function (cell) {
                const data = cell.getRow().getData()
                const paymentAmount = parseFloat(data.reservation_payment_amount) || 0
                const feePercent = parseFloat(data.reservation_fee) || 0
                const settlementAmount = paymentAmount * feePercent / 100
                return '₩' + settlementAmount.toLocaleString()
              }
            },
            {
              title: '결제취소금액',
              field: 'reservation_cancle_amount',
              headerSort: false,
              formatter: 'money',
              hozAlign: 'right',
              formatterParams: {
                decimal: '.',
                thousand: ',',
                symbol: '₩',
                precision: 0
              }
            },
            {title: '결제취소일자', field: 'reservation_cancle_date', headerSort: false},
            {
              title: '적립포인트',
              field: 'reservation_accumulated_points',
              headerSort: false,
              hozAlign: 'right',
              formatter: function (cell) {
                let value = cell.getValue()
                return value.toLocaleString() + 'P'
              }
            },
            {
              title: '사용포인트',
              field: 'reservation_use_points',
              headerSort: false,
              hozAlign: 'right',
              formatter: function (cell) {
                let value = cell.getValue()
                return value.toLocaleString() + 'P'
              }
            },
            {title: '입금자명', field: 'reservation_depositor_name', headerSort: false},
            {title: '현금영수증요청', field: 'reservation_cash_receipt_request', headerSort: false},
            {title: '환불계좌', field: 'reservation_refund_account', headerSort: false},
            {title: '요청사항', field: 'reservation_request', headerSort: false},
            {title: '관리자 메모', field: 'reservation_memo', headerSort: false}
          ],
          rowFormatter: (row) => {
            const data = row.getData()
            const element = row.getElement()

            if (data.reservation_pay_status === '결제대기') {
              element.style.backgroundColor = 'blue'
              element.style.color = 'white'
            }

            if (data.reservation_cancellation_request_status === '신청') {
              element.style.backgroundColor = 'red'
              element.style.color = 'white'
            }
          }
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/ReservationManagement/AdminReservationManagement.vue